import { ELandingType } from '../../types/landingType';
import { EActivateInsuranceStep } from '../../types/activateInsurance/step';
import { EJoinOtaLegalShortStep } from '../../types/joinOtaLegalShort/step';
import { EJoinOtaStep } from '../../types/joinOtaIndividual/step';
import { EBusinessEntityStep } from '../../types/businessEntityFlow/step';

export const isStepValidForLandingType = (landingType: ELandingType, step: string): boolean => {
  switch (landingType) {
    case ELandingType.ActivateInsurance:
      return Object.values(EActivateInsuranceStep).includes(step as EActivateInsuranceStep);
    case ELandingType.JoinOtaLegalShort:
      return Object.values(EJoinOtaLegalShortStep).includes(step as EJoinOtaLegalShortStep);
    case ELandingType.JoinOtaCian:
      return Object.values(EJoinOtaStep).includes(step as EJoinOtaStep);
    case ELandingType.BusinessEntityFlow:
      return Object.values(EBusinessEntityStep).includes(step as EBusinessEntityStep);
    default:
      return false;
  }
};
